import { createFileRoute, redirect } from '@tanstack/react-router'

/** Compatibility shim for the old combined Seats & Billing section. */
export const Route = createFileRoute('/_ws/w/$workspaceId/seats-billing')({
  beforeLoad: ({ params, location }) => {
    const suffix = location.pathname.split(`/w/${params.workspaceId}/seats-billing`)[1] ?? ''
    const target =
      suffix === '/billing'
        ? '/w/$workspaceId/billing'
        : suffix === '/plan'
          ? '/w/$workspaceId/billing/plan'
          : suffix === '/payment'
            ? '/w/$workspaceId/billing/payment'
            : '/w/$workspaceId/members'

    throw redirect({
      to: target,
      params: { workspaceId: params.workspaceId },
    })
  },
})
